import { useLocation } from 'react-router-dom';
import { useDiceRollerStore } from '../stores/diceRollerStore';
import { useDiceRoller } from '../hooks/useDiceRoller';
import { DiceRollerPanel } from './play-mode/DiceRollerPanel';
import { FloatingDiceIcon } from './play-mode/PlayModeIcons';

/**
 * Global dice roller component that can be used anywhere in the app.
 * Renders a floating button and the dice roller panel.
 */
export function GlobalDiceRoller() {
  const location = useLocation();
  const { isOpen, open, close } = useDiceRollerStore();
  const { rollPool } = useDiceRoller();

  // Detect if we're on the Play Mode page to adjust button position
  const isPlayMode = location.pathname.includes('/play');

  return (
    <>
      {/* Floating Dice Roller Button - z-[55] to appear above nav bars (z-40 dock, z-50 play mode) */}
      {/* Positioned higher on Play Mode to avoid overlapping the nav bar */}
      <button
        onClick={open}
        className={`fixed right-4 z-[55] w-14 h-14 bg-accent-gold hover:bg-accent-gold-light
          rounded-full shadow-lg shadow-accent-gold/30 flex items-center justify-center
          text-background-primary transition-all active:scale-95 hover:shadow-xl
          ${isPlayMode ? 'bottom-24' : 'bottom-6'}`}
        aria-label="Open dice roller"
      >
        <FloatingDiceIcon className="w-7 h-7" />
      </button>

      {/* Dice Roller Panel */}
      <DiceRollerPanel
        isOpen={isOpen}
        onClose={close}
        onRollPool={rollPool}
      />
    </>
  );
}
